import { ChevronRightIcon } from "@heroicons/react/24/outline"
import { okrLabels, OkrType } from "../okrLabels"

const MultipleObjInfoCard = ({
  type,
  onClick,
}: {
  type: OkrType
  onClick: () => void
}) => {
  const label = okrLabels[type]

  return (
    <div>
      <div className="bg-padeLightBlue px-4 py-5 flex items-start gap-3 mb-7">
        <div className="h-6 w-6 shrink-0">
          <img
            src="https://padehrs3-staging.s3.us-east-2.amazonaws.com/images/201afeb2-b885-495d-b3c1-db60903afd28.png"
            alt="bulk-upload"
            className="h-full w-full"
          />
        </div>

        <div className="flex flex-col">
          <h6 className="font-circular font-semibold mb-1 text-padeBlack ">
            Creating Multiple {label.plural}?
          </h6>
          <p className="font-avenir text-padeBlack">
            If you need to create several {label.lower}, consider using bulk
            upload to save time. You can upload a CSV file with all your{" "}
            {label.lower} at once.
          </p>
          <button
            className=" mt-3 text-primary500 flex items-center"
            onClick={onClick}
          >
            <span className="font-circular"> Use Bulk Upload Instead</span>{" "}
            <ChevronRightIcon className=" h-5 w-5 ml-1" />
          </button>
        </div>
      </div>
    </div>
  )
}

export default MultipleObjInfoCard
